import styled from "styled-components";

const ContactWindow = styled.div`
    position: fixed;    
    bottom: 0;
    right: 480px;
    width: 200px;
    height: 500px;
    max-height: calc(100% - 46px);
    flex-direction: column;
    box-shadow: 0 2px 4px #777777;
    z-index: 1;
`;

const ContactHeader = styled.div`
    height: 40px;
    background: #425b76;
    border-radius: 8px 8px 0 0;
`;

const ContactContent = styled.div`
    flex: 1;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 14px;
    color: #1f1f1f;

    .row-wrapper {
        cursor: pointer;

        &:hover, &.selected {
            background #AAD3701A;
        }

        .row {
            margin: 0 12px;
            padding: 12px 0;
            border-bottom: 1px solid #f0f0f0;
            line-height: 16px;
            display: flex;
            gap: 4px;

            .left-cell {
                flex: 1;
                overflow: hidden;

                .title {
                    font-weight: bold;
                    margin-bottom: 8px;
                }

                .descr {
                    color: #8c8c8c;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }

            .right-cell {
                font-size: 12px;
            
                .status {
                    text-align: end;

                    .status-icon {
                        width: 6px;
                        height: 6px;
                        background: #1677ff;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;

                        &::after {
                            position: absolute;
                            top: 0;
                            inset-inline-start: 0;
                            width: 100%;
                            height: 100%;
                            border-width: 1px;
                            border-style: solid;
                            border-radius: 50%;
                            animation: statusProcessing infinite 1.2s;
                            animation-timing-function: ease-in-out;
                            content: "";
                        }

                        @keyframes statusProcessing {
                            0% {
                                transform: scale(0.8);
                                opacity: 0.5;
                            }

                            to {
                                transform: scale(2.4);
                                opacity: 0;
                            }
                        }
                    }
                }
            }
        }
    }
`;
const MessageWindow = styled.div`
    position: fixed;    
    bottom: 0;
    right: 80px;
    width: 400px;
    height: 500px;
    max-height: calc(100% - 46px);
    flex-direction: column;
    box-shadow: 0 2px 4px #777777;
    z-index: 1;
`;

const MessageHeader = styled.div`
    padding: 12px;
    text-align: right;
    background: #425b76;
    border-radius: 8px 8px 0 0;
`;

const MessageContent = styled.div`
    flex: 1;
    background: #fff;
    overflow: auto;
    color: #425b76;
    
    .row-wrapper {
        display: grid;
        gap: 16px;
        overflow: hidden;
        padding: 8px 16px;

        .row {
            display: flex;
            gap: 8px;

            &.left {
                margin-right: 48px;
            }

            &.right {
                margin-left: 48px;
                flex-direction: row-reverse;
            }
        }

        .dialog {
            border: 1px solid #cbd6e2;
            border-radius: 8px;
            padding: 8px;
            font-size: 14px;
            line-height: 24px;
            position: relative;

            &.left {
                background: #eaf0f6;

                &:before {
                    content: "";
                    position: absolute;
                    border: 10px solid transparent;
                    border-right: 11px solid #eaf0f6;
                    left: -20px;
                    top: 8px;
                }
            }

            &.right {
                background: #d6e6f7;
                justify-self: right;

                &:after {
                    content: "";
                    position: absolute;
                    border: 10px solid transparent;
                    border-left: 11px solid #d6e6f7;
                    right: -20px;
                    top: 8px;
                }
            }
        }

        .date {
            font-size: 12px;
            margin: 8px auto;
        }

        .time {
            font-size: 12px;
            align-self: end;
        }
    }
`;

const MessageFooter = styled.div`
    padding: 12px;
    display: flex;
    gap: 12px;
    background: #fff;
    border-top: 2px solid #f2f5f8;
`;

export {
    ContactWindow,
    ContactHeader,
    ContactContent,
    MessageWindow,
    MessageHeader,
    MessageContent,
    MessageFooter
};